import { type IObservableArray, runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Campaign, DisplayCreative } from '@feathr/blackbox';
import Creative from '@feathr/extender/components/Creative';
import { useStore } from '@feathr/extender/state';
import { moment } from '@feathr/hooks';

interface IListProps {
  creatives: IObservableArray<DisplayCreative>;
  campaign: Campaign;
}

function CreativesList({ creatives, campaign }: Readonly<IListProps>): JSX.Element {
  const { Creatives } = useStore();

  function removeCreative(creative: DisplayCreative): void {
    if (creative.isEphemeral) {
      creatives.remove(creative);
      Creatives.remove(creative.get('id'));
    } else {
      runInAction(() => {
        creative.set({ is_archived: true });
        creative.patchDirty();
        // Update the observable array to trigger a re-render
        creatives.replace(creatives.filter((c) => c.get('id') !== creative.get('id')));
      });
    }
  }

  return (
    <>
      {creatives
        .filter((c) => !c.get('is_archived'))
        .sort((a, b) => moment.utc(a.get('date_created')).diff(moment.utc(b.get('date_created'))))
        .map((creative) => {
          return (
            <Creative
              campaign={campaign}
              creative={creative}
              key={creative.listId}
              onRemove={removeCreative}
            />
          );
        })}
    </>
  );
}

export default observer(CreativesList);
